// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rpsc/XDL/types";
import { color, getSystemColor } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

const _sharedNestedListStyles = `
    padding: 0;
    margin: 0;
    & ul, & ol {
        margin: 24px 20px;
    }
`;

export default {
    defaultProps: {
        css: css`
            ul,
            ol {
                padding: 0;
                margin: 0;
            }
        `,
    },
    unorderedListProps: {
        css: css`
            ${_sharedNestedListStyles}
            li {
                display: flex;
                align-items: flex-start;
            }
            li::before {
                content: "";
                min-width: 4px;
                height: 4px;
                border-radius: 50%;
                background: ${color("common.black")};
                margin-right: 8px;
                margin-top: 6px;
            }
        `,
    },
    orderedListProps: {
        css: css`
            & ol {
                list-style-type: lower-alpha;
            }
            ${_sharedNestedListStyles}
        `,
    },
    listItemProps: {
        css: css`
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0;
            color: ${getSystemColor("text.main")};
            line-height: 26px;
            margin-bottom: 16px;
        `,
    },
} as xBaseTheme["lists"];
